var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M8.00008 14.1001C11.369 14.1001 14.1001 11.3691 14.1001 8.00015C14.1001 4.63121 11.369 1.90015 8.00008 1.90015C4.63115 1.90015 1.90009 4.63121 1.90009 8.00015C1.90009 11.3691 4.63115 14.1001 8.00008 14.1001Z",
    fill: "#17B26A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66669 8.34165L7.22748 9.90078C7.97817 8.58814 9.01706 7.46305 10.2658 6.61032L10.3334 6.56421M14.1001 8.00015C14.1001 11.3691 11.369 14.1001 8.00008 14.1001C4.63115 14.1001 1.90009 11.3691 1.90009 8.00015C1.90009 4.63121 4.63115 1.90015 8.00008 1.90015C11.369 1.90015 14.1001 4.63121 14.1001 8.00015Z",
    stroke: "#17B26A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTickCircle);
export default __webpack_public_path__ + "static/media/check-tick-circle.15a0dfc49dc13d3929e8b4d7ae2b3a97.svg";
export { ForwardRef as ReactComponent };